import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Layout, Button, ConfigProvider } from 'antd';
import SidebarOfficial from './Components/Sidebar';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ptBR from 'antd/lib/locale/pt_BR';
import Contatos from './Pages/Contatos';


const { Header, Footer, Sider, Content } = Layout;

const customLocale = {
  ...ptBR,
  Pagination: {
    ...ptBR.Pagination,
    items_per_page: '/ página',
    colorPrimary: '#AA965D',
  },
};

const tokenConfig = {
  token: {
    colorPrimary: '#AA965D',
    colorPrimaryBorder: 'rgba(20, 29, 69, 0.53)',
    colorPrimaryHover: '#AA965D',
  },
};

const App = () => {
  // Use o estado para controlar se o sidebar está colapsado
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768);
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      // Colapsa o sidebar automaticamente em telas menores
      if (window.innerWidth < 768) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Router>
      <AuthProvider>
        {isAuthenticated() ? (
          <ConfigProvider locale={customLocale} theme={tokenConfig}>
            <Layout style={{ minHeight: '100vh' }}>
              <SidebarOfficial collapsed={collapsed} toggleCollapsed={toggleCollapsed} userLevel='0'/>

              <Layout>
                <Content style={{ margin: '2rem 16px' }}>
                  <Routes>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/contatos' element={<Contatos />} />
                  </Routes>

                  <ToastContainer />
                </Content>
                {/* <Footer style={{ textAlign: 'center' }}>Seu Footer</Footer> */}
              </Layout>
            </Layout>
          </ConfigProvider>
        ) : (
          <Login />
        )}
        <ToastContainer />
      </AuthProvider>
    </Router>
  );
};

export default App;
